module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/1-9cfc674eb7958b9b352fa33732a307be.jpeg";